import { api } from './client';

export interface CashOperationDto {
  id: number;
  date: string;
  documentNumber: string;
  content: string;
  documentType: string;
  personId: number | null;
  totalDebit: number;
  totalCredit: number;
  lines: Array<{
    id: number;
    account: number;
    accountName: string;
    amount: number;
    entryType: string;
    personId: number | null;
  }>;
}

export interface CreateCashOperationRequest {
  cashType?: string;
  date: string;
  documentNumber: string;
  content: string;
  cashAccount: number;
  correspondenceAccount: number;
  amount: number;
  personId?: number | null;
  currencyCode?: string;
  currencyRate?: number;
  autoSerialCode?: string;
}

export const cashOperationsApi = {
  list: (params: { from?: string; to?: string; cashType?: string } = {}) =>
    api.get<CashOperationDto[]>('/cash-operations', {
      from: params.from,
      to: params.to,
      cashType: params.cashType,
    }),

  getById: (id: number) =>
    api.get<CashOperationDto>(`/cash-operations/${id}`),

  create: (data: CreateCashOperationRequest) =>
    api.post<number>('/cash-operations', data),

  update: (id: number, data: Omit<CreateCashOperationRequest, 'cashType' | 'currencyCode' | 'currencyRate'>) =>
    api.put<void>(`/cash-operations/${id}`, data),

  delete: (id: number) =>
    api.delete<void>(`/cash-operations/${id}`),
};
